import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackToCta } from "@faire/help-center-utils/components/BackToCta/BackToCta";
import { BackToDestination } from "@faire/help-center-utils/components/BackToCta/types";
import { trackHelpCenterBackToClick } from "@faire/web-api/events/helpCenter/click/backTo";
import { Flex } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
import { useChatCsatStore } from "../hooks/ChatCsatContextStore";
export var ChatCsatCollected = function ChatCsatCollected() {
  var _useChatCsatStore = useChatCsatStore(["surveyType"]),
    _useChatCsatStore2 = _slicedToArray(_useChatCsatStore, 1),
    surveyType = _useChatCsatStore2[0].surveyType;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "pageHeaderSerifRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "SpEbyA",
    defaultMessage: [{
      "type": 0,
      "value": "Agradecemos o tempo que dedicou a partilhar a sua opinião."
    }]
  })), surveyType !== "chat" ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(BackToCta, {
    destination: BackToDestination.HELP_CENTER,
    onClick: function onClick() {
      return trackHelpCenterBackToClick("help_center");
    }
  }), /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }), /*#__PURE__*/React.createElement(BackToCta, {
    variant: "secondary",
    destination: BackToDestination.FAIRE,
    onClick: function onClick() {
      return trackHelpCenterBackToClick("faire_home");
    }
  })))) : null);
};
var ButtonWrapper = styled(Flex).attrs({
  justify: "space-between",
  direction: {
    tabletAndAbove: "row",
    mobileAndAbove: "column"
  }
}).withConfig({
  displayName: "ChatCsatCollected__ButtonWrapper"
})([""]);